import { Avatar as AvatarMUI, SvgIcon } from "@mui/material";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import "./avatar.scss";

export const Avatar = (props: any) => {
  const { icon, badge, src, alt, size, altIcon, ...rest } = props;
  const avatarStyle = {
    height: size,
    width: size,
  };

  const fontSize = size * (alt && alt.split(" ").length > 1 ? 0.025 : 0.035);
  const badgeSize = size * 0.0225;
  const badgeBorder = size * 0.004;
  let altFirstChar = "";

  if (alt && alt.length > 0) {
    const words = alt.split(" ");
    altFirstChar = words.map((word: string) => word.charAt(0)).join("");
  }

  return (
    <div className="Avatar">
      <AvatarMUI
        alt={alt}
        src={src ? src : undefined}
        style={avatarStyle}
        {...rest}
      >
        {icon && (!src || (alt && alt.length === 0)) && (
          <>
          {altIcon ? (
            <SvgIcon>{altIcon}</SvgIcon>
          ) : (
            <Person2OutlinedIcon
              style={{ fontSize: `${fontSize + 0.8}rem` }}
            />
          )}
        </>
        )}
        {!icon && !src && (
          <span
            className="Avatar--FirstChar"
            style={{ fontSize: `${fontSize}rem` }}
          >
            {altFirstChar}
          </span>
        )}
      </AvatarMUI>

      {badge && (
        <div
          className="Avatar--Badge"
          style={{
            width: `${badgeSize}rem`,
            height: `${badgeSize}rem`,
            border: `${badgeBorder}rem solid #ffffff`,
          }}
        />
      )}
    </div>
  );
};

export default Avatar;
